import React from "react";
import classNames from "classnames";

import styles from "./P.module.scss";

interface Props {
    children: React.ReactNode;
}

// WeLeap legacy global css comes with default margin and padding. We would like migrate all the <p /> element to have no default margin and padding gradually
const P = ({ children, className, ...rest }: Props & JSX.IntrinsicElements["p"]) => {
    return (
        <p className={classNames(styles["p"], className)} {...rest}>
            {children}
        </p>
    );
};

export default P;
